import { useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { GRID_COL_INDEX_ATTRIBUTE, GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';

interface CpsGridCellProps extends GridCustomCellProps {
  children: React.ReactNode;
  title: string;
  customStyle?: React.CSSProperties;
}

type CpsGridTdElementProps = React.TdHTMLAttributes<HTMLTableCellElement> &
  Partial<Record<typeof GRID_COL_INDEX_ATTRIBUTE, number>>;

export const CpsGridCell: React.FC<CpsGridCellProps> = props => {
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  const { tdProps, title, className, style, customStyle, colSpan, ariaColumnIndex, isSelected } = props;

  const tdClassName =
    typeof tdProps?.className === 'string'
      ? [tdProps.className, className].filter(Boolean).join(' ')
      : [className].filter(Boolean).join(' ');

  const tdElementProps: CpsGridTdElementProps = {
    ...(tdProps ?? {}),
    title,
    className: tdClassName,
    style: { ...tdProps?.style, ...style, ...customStyle },
    colSpan,
    role: 'gridcell',
    'aria-colindex': ariaColumnIndex,
    'aria-selected': isSelected,
    ...navigationAttributes
  };

  // eslint-disable-next-line react/jsx-props-no-spreading -- required merge of Kendo tdProps onto td
  return <td {...tdElementProps}>{props.children}</td>;
};
